import { DefaultTheme } from 'styled-components';
import staticTheme from './default';
import { getAntdTokens } from './getThemeAntd';

const antdTokens = getAntdTokens('dark');

const darkTheme: DefaultTheme = {
    colors: {
        backgroundColor: 'black',
        black: '#000',
        green: '#12776e',
        translucentGreen: '#12776ebf',
        white: '#fff',
        accentColor: '#4b7cf3',
        secondaryColor: '#78a3ff',
        selectedColor: '#78a3ff',
        componentBackground: '#141414',
        lightGrey: '#e4e9f0',
        fail: '#f5222e',
        sucess: '#41b883',

        darkFont: '#141322',
        lightFont: '#ffffff',
        font: '#FFFFFF',

        /**
         * ANTD
         */
        antdBorder: antdTokens.colorBorder,
        antdBorderSecondary: antdTokens.colorBorderSecondary,
        antdBackground: antdTokens.colorBgContainer,
        antdText: antdTokens.colorText,
        antdTextSecondary: antdTokens.colorTextSecondary,
        antdPrimary: antdTokens.colorPrimary,
        colorBgContainer: antdTokens.colorBgContainer,
        colorBgElevated: antdTokens.colorBgElevated,
        colorPrimaryHover: antdTokens.colorPrimaryHover,
    },
    ...staticTheme,
    borderRadius: {
        default: `${antdTokens.borderRadius}px`,
    },
    theme: 'dark',
};

export default darkTheme;
